module.exports = __webpack_public_path__ + "static/media/notifications_black.df93d1c1.svg";